module.exports = __webpack_public_path__ + "img/circle_opaque.32cf250f.svg";